<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="$route.params.id ? actions : []"
    :form="form"
    :title="$t('model.merchant')"
    resource="merchants"
    :batchActions="batchActions"
    :actionColumnProps="{ width: 220 }"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/merchants.js';
import _ from 'lodash';
import Qrcode from '@/components/qrcode.vue';

@Component
export default class Merchants extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'name_cont',
      {
        key: 'store_owner_id_eq',
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            xRemotePreload: async () => {
              const { data } = await this.$request.get('/store_owners/read_options', { per_page: 100 })
              return _.map(data, ({ id, name }) => ({ value: id, label: name }))
            },
            xRemoteSearch: async (keyword) => {
              const { data } = await this.$request.get('/store_owners/read_options', { keyword })
              return _.map(data, ({ id, name }) => ({ value: id, label: name }))
            }
          }
        }
      },
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      {
        key: 'name',
        width: 180,
      },
      type === 'show' && {
        prop: 'collect_qr_code_url',
        label: this.$t('merchant.qrCode'),
        renderCell: (h, { props: { value, scope: { row } } }) => <Qrcode downloadFileName={`qrcode-${row.store_owner.name}`} text={value} />
      },
      {
        key: 'store_owner',
        width: 200,
        renderCell: (h, { props: { value } }) => {
          if (value) {
            return <bean-link to={{ name: 'store_owners.show', params: { id: value.id } }}>{value.name}</bean-link>
          }
        }
      },
      {
        key: 'explore_tag_list',
        minWidth: 150,
        renderCell: (h, { props: { value } }) => {
          return (_.map(value, (tag) => (<el-tag style={{ 'margin-right': '3px' }}>{tag.length > 10 ? (tag.slice(0, 10) + '...') : tag}</el-tag>)))
        }
      },
      type === 'show' && {
        key: 'phone',
        width: 250,
      },
      type === 'show' && 'whatsapp',
      type === 'show' && 'instagram',
      type === 'show' && 'gozem',
      {
        prop: 'agent',
        label: this.$t('model.agent'),
        renderCell: (h, { props: { value } }) => {
          if (value) {
            return <bean-link to={{ name: 'agents.show', params: { id: value.id } }}>
              {value.phone} ({this.$t(`agent.statuses.${value.status}`)}{value.locked_at ? `, ${this.$t('suspended')}` : ''})
            </bean-link>
          }
        }
      },
      {
        key: 'show_on_places_section',
        width: 220,
      },
      {
        key: 'show_on_catalog',
        width: 220,
      },
      {
        key: 'show_on_explore_section',
        width: 220,
      },
      type === 'show' && {
        prop: 'cashback_percent',
        label: this.$t('event.cashbackPercent'),
        renderCell: (h, { props: { scope: { row } } }) => {
          if (row.not_expired_event) {
            return <bean-link to={{ name: 'events.show', params: { id: row.not_expired_event.id } }}>{row.not_expired_event.cashback_percent}</bean-link>
          }
        }
      },
      type === 'show' && 'introduction',
      type === 'show' && 'location',
      type === 'show' && 'latitude',
      type === 'show' && 'longitude',
      type === 'show' && 'logo',
      type === 'show' && 'follows_count',
      'cover',
      type === 'show' && 'images',
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      'name',
      {
        key: 'store_owner_id',
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            xRemotePreload: async () => {
              const { data } = await this.$request.get('/store_owners/read_options', { per_page: 100 })
              return _.map(data, ({ id, name }) => ({ value: id, label: name }))
            },
            xRemoteSearch: async (keyword) => {
              const { data } = await this.$request.get('/store_owners/read_options', { keyword })
              return _.map(data, ({ id, name }) => ({ value: id, label: name }))
            }
          },
          domProps: {
            style: 'width: 100%'
          }
        }
      },
      {
        prop: 'explore_tag_list',
        label: this.$t('merchant.exploreTagList'),
        renderCell: {
          component: 'select',
          domProps: { style: 'width: 100%' },
          props: {
            clearable: true,
            multiple: true,
            filterable: true,
            xRemotePreload: async () => {
              const data = await this.$request.get('acts_as_taggable_on/tags/read_options', { page: 0, kind_eq: "explore" })
              return _.map(data, ({ name }) => ({ value: name, label: name }))
            }
          }
        }
      },
      'phone',
      'whatsapp',
      'instagram',
      'gozem',
      'location',
      'latitude',
      'longitude',
      'introduction',
      {
        key: 'logo',
        renderCell: {
          hint: `${this.$t('suggestSize')}: 300x300`,
        }
      },
      {
        key: 'cover',
        renderCell: {
          hint: `${this.$t('suggestSize')}: 288x195`,
        }
      },
      {
        key: 'images',
        renderCell: {
          hint: `${this.$t('suggestSize')} < 500kb`,
          props: {
            limit: 9,
          }
        }
      },
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove, reload }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'merchants.edit', params: { id: row.id } }
        }
      },
      row.show_on_places_section && {
        component: 'confirmButton',
        props: {
          label: this.$t('merchant.removeFromPlacesSection'),
          type: 'danger',
          can: 'merchants.update'
        },
        on: {
          confirm: async () => {
            await this.$request.put('/merchants/batch_update', { ids: [row.id], show_on_places_section: false });
            this.$message.success(this.$t('bean.updateSuccess'));
            reload();
          }
        }
      },
      !row.show_on_places_section && {
        component: 'confirmButton',
        props: {
          label: this.$t('merchant.addToPlacesSection'),
          type: 'primary',
          can: 'merchants.update'
        },
        on: {
          confirm: async () => {
            await this.$request.put('/merchants/batch_update', { ids: [row.id], show_on_places_section: true });
            this.$message.success(this.$t('bean.updateSuccess'));
            reload();
          }
        }
      },
      row.show_on_catalog && {
        component: 'confirmButton',
        props: {
          label: this.$t('merchant.removeFromMerchantCatalog'),
          type: 'danger',
          can: 'merchants.update'
        },
        on: {
          confirm: async () => {
            await this.$request.put('/merchants/batch_update', { ids: [row.id], show_on_catalog: false });
            this.$message.success(this.$t('bean.updateSuccess'));
            reload();
          }
        }
      },
      !row.show_on_catalog && {
        component: 'confirmButton',
        props: {
          label: this.$t('merchant.addToMerchantCatalog'),
          type: 'primary',
          can: 'merchants.update'
        },
        on: {
          confirm: async () => {
            await this.$request.put('/merchants/batch_update', { ids: [row.id], show_on_catalog: true });
            this.$message.success(this.$t('bean.updateSuccess'));
            reload();
          }
        }
      },
      row.show_on_explore_section && {
        component: 'confirmButton',
        props: {
          label: this.$t('merchant.removeFromExploreSection') + ' (Deprecated in next APP version)',
          type: 'danger',
          can: 'merchants.update'
        },
        on: {
          confirm: async () => {
            await this.$request.put('/merchants/batch_update', { ids: [row.id], show_on_explore_section: false });
            this.$message.success(this.$t('bean.updateSuccess'));
            reload();
          }
        }
      },
      !row.show_on_explore_section && {
        component: 'confirmButton',
        props: {
          label: this.$t('merchant.addToExploreSection') + ' (Deprecated in next APP version)',
          type: 'primary',
          can: 'merchants.update'
        },
        on: {
          confirm: async () => {
            await this.$request.put('/merchants/batch_update', { ids: [row.id], show_on_explore_section: true });
            this.$message.success(this.$t('bean.updateSuccess'));
            reload();
          }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'merchants.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }

  /**
   * @param {Object} scope -表格 scope 数据
   * @param {Object} scope.selection - 表格已选择行数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
   batchActions({ selection }, { reload }) {
    const handleBatchUpdateAction = async (column, actionI18nKey) => {
      await this.$confirm(`${this.$t('bean.actionConfirm')} ${this.$t(actionI18nKey)}`, '');
      const body = { ids: _.map(selection, 'id') };
      body[column] = true;
      await this.$request.put('/merchants/batch_update', body);
      this.$message.success(this.$t('bean.updateSuccess'));
      reload();
    }

    return [
      selection.length > 0 ? () => <el-button type="primary" onClick={() => handleBatchUpdateAction('show_on_places_section', 'merchant.addToPlacesSection')}>{this.$t('merchant.addToPlacesSection')}  ({ selection.length })</el-button> :
        () => <el-button type="primary" disabled>{this.$t('merchant.addToPlacesSection')} ({ selection.length })</el-button>,
      selection.length > 0 ? () => <el-button type="primary" onClick={() => handleBatchUpdateAction('show_on_catalog', 'merchant.addToMerchantCatalog')}>{this.$t('merchant.addToMerchantCatalog')}  ({ selection.length })</el-button> :
        () => <el-button type="primary" disabled>{this.$t('merchant.addToMerchantCatalog')} ({ selection.length })</el-button>,
      selection.length > 0 ? () => <el-button type="primary" onClick={() => handleBatchUpdateAction('show_on_explore_section', 'merchant.addToExploreSection')}>{this.$t('merchant.addToExploreSection')}  ({ selection.length })</el-button> :
        () => <el-button type="primary" disabled>{this.$t('merchant.addToExploreSection')} ({ selection.length })</el-button>,
    ];
  }
}

export const route = [
  {
    path: '/merchants',
    name: 'merchants.index',
    component: Merchants,
    props: {
      type: 'index',
    }
  },
  {
    path: '/merchants/new',
    name: 'merchants.new',
    component: Merchants,
    props: {
      type: 'new',
    }
  },
  {
    path: '/merchants/:id',
    name: 'merchants.show',
    component: Merchants,
    props: {
      type: 'show',
    }
  },
  {
    path: '/merchants/:id/edit',
    name: 'merchants.edit',
    component: Merchants,
    props: {
      type: 'edit'
    }
  }
]
</script>
